import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex)
import session from 'sessionstorage'
import kiwiweb_config from '../../static/kiwiweb.config.json'
import axios from 'axios'

import { mapGetters } from 'vuex'
import { mapMutations } from 'vuex'
import { mapActions } from 'vuex'

export const store = new Vuex.Store({
    state: {
        display_navigation_components: false,
        display_navbar_component: false,
        display_sidenav_component: false,

        authenticated: false,
        user_session: '',
        plant_info: '',

        subdomain: '',

        shopping_cart_count: '',

        requested_route: ''
    },
    getters: {
        requested_route: function(state){
            return state.requested_route
        },
        display_navigation_components: function(state){
            return state.display_navigation_components
        },
        display_navbar_component: function(state){
            return state.display_navbar_component
        },
        display_sidenav_component: function(state){
            return state.display_sidenav_component
        },

        authenticated: function(state){
            return state.authenticated
        },
        user_session: function(state){
            return state.user_session
        },
        plant_info: function(state){
            return state.plant_info
        },
    

        subdomain: function(state){
            return state.subdomain
        },
        
        shopping_cart_count: function(state){
            console.log('getting shop cart count')
            return state.shopping_cart_count
        }
        
    },
    mutations: {
        set_requested_route(state, requested_route){
            state.requested_route = requested_route
        },
        set_display_navigation_components(state, display){
            state.display_navigation_components = display
        },
        set_display_navbar_component(state, display){
            state.display_navbar_component = display

        },
        set_display_sidenav_component(state, display){
            state.display_sidenav_component = display
            
        },

        set_authenticated(state, authenticated){
            state.authenticated = authenticated;
        },
        set_user_session(state, user_session){
            state.user_session = user_session;
        },
        set_plant_info(state, plant_info){
            state.plant_info = plant_info;
        },

        set_subdomain(state, subdomain){
            state.subdomain = subdomain
        },

        set_shopping_cart_count(state, shopping_cart_count){
            state.shopping_cart_count = shopping_cart_count
        }
    },
    actions: {
        async set_requested_route(context, requested_route){
            context.commit('set_requested_route', await requested_route)
        },
        async set_display_navigation_components(context, display){
            context.commit('set_display_navigation_components', await display)

        },
        async set_display_navbar_component(context, display){
            context.commit('set_display_navbar_component', await display)

        },
        async set_display_sidenav_component(context, display){
            context.commit('set_display_sidenav_component', await display)

        },

        async set_authenticated(context){
            var authenticated = session.getItem('user_authenticated')

            context.commit('set_authenticated', authenticated)
            return Promise.resolve()

        },
        async set_user_session(context){

            context.commit('set_user_session', JSON.parse(session.getItem('user')))
            return Promise.resolve();
            

        },
        async set_plant_info(context){
            var user_session = JSON.parse(session.getItem('user'))


            var request_package = {
                user: user_session
            };
            console.log(user_session)

            if(user_session.plantIDs != null){
                console.log("plant ids arenot null")
                axios.post(kiwiweb_config.kwwa.api.url + '/api/plants', {'request_package': request_package})
                .then(function(response){
                    console.log(response.data)
                    context.commit('set_plant_info', response.data)
                }) 
            }
            
        },

        async set_shopping_cart_count(context){
            var user_session = JSON.parse(session.getItem('user'))


            var request_package = {
                user: user_session
            };

            axios.post(kiwiweb_config.kwwa.api.url + '/dtapi/shopping_cart/get', {'request_package': request_package})
            .then(function(response){
                var items = response.data.data
                context.commit('set_shopping_cart_count', items.length)
            })
           
        }
    }
  });


// WEBPACK FOOTER //
// ./src/storage/vuex-store.js